import { pageLocation } from "@/services/pageLocation";
const isInIframe = typeof window !== "undefined" && window.self !== window.top;
const flag =
  typeof window !== "undefined" &&
  new URLSearchParams(pageLocation().search).get("compareMode") === "1";

export const COMPARE_MODE = isInIframe && flag;

if (COMPARE_MODE && typeof document !== "undefined") {
  document.documentElement.classList.add("compare-mode");
}
